<template>
    <div class="pages">
        <el-pagination
          background
          @current-change="handleCurrentChange"
          @size-change="handleSizeChange"
          :current-page="currentPage"
          :page-size="pageSize"
          :page-sizes="pageSizes"
          :layout="pageLayout"
          :total="total"
        >
        </el-pagination>
      </div>
  </template>

<script>
export default {
  name: 'GlobalPagination',
  props: {
    total: {
      type: Number,
      default: 0
    },
    currentPage: {
      type: Number,
      default: 1
    },
    pageSize: {
      type: Number,
      default: 10
    },
    pageSizes: {
      type: Array,
      default: () => [5, 10, 20, 50, 100, 200, 500]
    },
    pageLayout: {
      type: String,
      default: 'total, sizes, prev, pager, next, jumper'
    }
  },
  data () {
    return {}
  },
  computed: {
  },
  watch: {
  },
  created () {
  },
  methods: {
    handleCurrentChange (value) {
      this.$emit('update:current-page', value)
      this.$emit('current-change', value)
    },
    handleSizeChange (value) {
      this.$emit('update:page-size', value)
      this.$emit('size-change', value)
    }
  }
}
</script>

  <style scoped lang="scss">
   .pages {
      display: flex;
      justify-content: flex-end;
      padding: 10px 0 10px 10px;
      margin-top: 10px;
      background-color: #fff;
      .el-pagination{
        padding: 0;
      }
    }
  </style>
